export default "__VITE_ASSET__BOWo1SFj__"